import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edit\">\r\n    <title>bianjichangsuo</title>\r\n    <path d=\"M10.701 20.766c0.588 0.588 1.512 0.588 2.058 0l16.1-16.086c0.588-0.588 0.588-1.512 0-2.086s-1.512-0.588-2.058 0l-16.1 16.086c-0.588 0.588-0.588 1.498 0 2.086z\" fill=\"#1a1a1a\" />\r\n    <path d=\"M28.523 13.542c-0.798 0-1.47 0.644-1.47 1.47v11.788h-22.106v-22.092h11.788c0.798 0 1.442-0.644 1.47-1.47 0-0.798-0.644-1.47-1.442-1.47h-13.3c-0.798-0.014-1.47 0.63-1.47 1.456v25.046c0 0.406 0.154 0.77 0.434 1.050s0.644 0.434 1.050 0.434h25.046c0.406 0 0.77-0.154 1.050-0.434s0.434-0.644 0.434-1.050v-13.258c-0.014-0.826-0.686-1.47-1.484-1.47z\" fill=\"#1a1a1a\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edit.svg
// module id = ql+d
// module chunks = 14